import _defineProperty from "/home/runner/work/brand/brand/apps/docs/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/brand/brand/apps/docs/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "variant", "auxiliaryText", "selectionVariant", "role", "sx"],
    _excluded2 = ["variant", "title", "auxiliaryText", "labelId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { useSSRSafeId } from '@react-aria/ssr';
import Box from '../Box';
import { ListContext } from './List';
export var GroupContext = /*#__PURE__*/React.createContext({});
export var Group = function Group(_ref) {
  var title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'subtle' : _ref$variant,
      auxiliaryText = _ref.auxiliaryText,
      selectionVariant = _ref.selectionVariant,
      role = _ref.role,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var labelId = useSSRSafeId();

  var _React$useContext = React.useContext(ListContext),
      listRole = _React$useContext.role;

  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "li",
    role: listRole ? 'none' : undefined,
    sx: _objectSpread({
      '&:not(:first-child)': {
        marginTop: 2
      },
      listStyle: 'none'
    }, sx)
  }, props), title && /*#__PURE__*/React.createElement(Header, {
    title: title,
    variant: variant,
    auxiliaryText: auxiliaryText,
    labelId: labelId
  }), /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: {
      selectionVariant: selectionVariant
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: "ul",
    sx: {
      paddingInlineStart: 0
    },
    "aria-labelledby": title ? labelId : undefined,
    role: role || listRole && 'group'
  }, props.children)));
};
Group.displayName = "Group";
/**
 * Displays the name and description of a `Group`.
 *
 * For visual presentation only. It's hidden from screen readers.
 */

var Header = function Header(_ref2) {
  var variant = _ref2.variant,
      title = _ref2.title,
      auxiliaryText = _ref2.auxiliaryText,
      labelId = _ref2.labelId,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _React$useContext2 = React.useContext(ListContext),
      listVariant = _React$useContext2.variant;

  var styles = _objectSpread({
    paddingY: '6px',
    paddingX: listVariant === 'full' ? 2 : 3,
    fontSize: 0,
    fontWeight: 'bold',
    color: 'fg.muted'
  }, variant === 'filled' && {
    backgroundColor: 'canvas.subtle',
    marginX: 0,
    marginBottom: 2,
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'neutral.muted'
  });

  return /*#__PURE__*/React.createElement(Box, _extends({
    sx: styles,
    role: "presentation",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("span", {
    id: labelId
  }, title), auxiliaryText && /*#__PURE__*/React.createElement("span", null, auxiliaryText));
};

Header.displayName = "Header";